import React from 'react';
import { connect } from 'dva';
import { Dispatch } from 'redux';

import Person, { PersonComponentProps } from '../../shared/Person/Person';
import {
  getOnBlur,
  getOnCitizenshipChange,
  getPayload,
  setErrorToSecondParentRelativeFields,
  trimOnBlur,
} from '../../../helpers/handlers';
import { CHILD, ChildProps } from '../../../models/child';

const Child = function ({
  onChange,
  onBlur,
  handleFIOBlur,
  onCitizenshipChange,
  validatePassportOnBlur,
  ...child
}: PersonComponentProps & { validatePassportOnBlur(): void }): JSX.Element {
  return (
    <Person
      person={child}
      onChange={onChange}
      children={null}
      model={CHILD}
      onBlur={(event) => {
        validatePassportOnBlur();
        onBlur(event);
      }}
      handleFIOBlur={handleFIOBlur}
      onCitizenshipChange={onCitizenshipChange}
    />
  );
};

const mapStateToProps = ({ child }): ChildProps => child;

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChange(event) {
    const payload = getPayload(event);
    if (event.target.name === 'birthdate') {
      dispatch({
        type: `${CHILD}/reset/issueDate`,
      });
      setErrorToSecondParentRelativeFields(dispatch, CHILD, [
        'paternityRegisterDate',
      ]);
      dispatch({
        type: `${CHILD}/reset/passport/status`,
        payload: { namespace: CHILD },
      });
    }

    dispatch({
      type: `${CHILD}/onChange`,
      payload,
    });
  },
  onBlur: getOnBlur(CHILD, dispatch),
  validatePassportOnBlur() {
    dispatch({
      type: `${CHILD}/passport/validity`,
    });
  },
  handleFIOBlur: trimOnBlur(CHILD, dispatch),
  onCitizenshipChange: getOnCitizenshipChange(CHILD, dispatch),
});
const ChildContainer = connect(mapStateToProps, mapDispatchToProps)(Child);

export { ChildContainer as Child };
